import mainTheme from '@kimuno/theme';
import { useMediaQuery } from '@mui/material';

import { routes } from '../constants';
import useRouter from './useRouter';

export const useIsSidebarCollapsed = () => {
	const {
		match: {
			location: { pathname },
		},
	} = useRouter();
	const isReaderPage = pathname.includes(`/${routes.reader.root}/`);
	const isSidebarCollapsed =
		useMediaQuery(mainTheme.breakpoints.down('lg'), { noSsr: true }) || isReaderPage;
	return isSidebarCollapsed;
};
